<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.payment_methods }}
							</h6>
							<div class="element-box-tp">

								<div v-if="status > 0">
									<div class="alert alert-danger" v-if="status == 403">
										{{ t.error.access_denied_content }}
									</div>
									<div class="alert alert-danger" v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</div>
								</div>
								<table-component
										v-if="status == 200"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="payments"
								>
									<template>
										<table-column>
											<template scope="row">
												<router-link :to="{ }" v-if="row.name">
													{{ row.name }}
												</router-link>
											</template>
										</table-column>
										<table-column cell-class="w50">
											<template scope="row">
												<span v-if="row.is_active">
														<i class="icon-check"></i>
												</span>
												<span v-else>
														<i class="icon-close"></i>
												</span>
											</template>
										</table-column>
									</template>
								</table-component>

								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>

							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<userWidget :collapsed="true" :title="t.user.last_login" :filter="{ per_page: 10, short: 'lastLogin', direction: 'desc', loginDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss')}}" />
					<userWidget :collapsed="true" :title="t.last_activity" :filter="{ per_page:10, short: 'lastActivityAt', direction: 'desc', activityDate: {from: moment().utc().add(-30, 'm').format('YYYY-MM-DD HH:mm:ss'), to: moment().utc().format('YYYY-MM-DD HH:mm:ss') } }" />
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>
	</div>
</template>

<script>
    import userWidget from '@/components/user/widget/userWidget'
    import { TableComponent, TableColumn } from 'vue-table-component'
    export default {
        components:{ TableComponent, TableColumn, userWidget},
        name: 'paymentList',
        data () {
            return {
                t: this.$root.t,
                payments: null,
	            status: 0
            }
        },
	    mounted () {
			this.fetchPayments()
	    },
	    methods: {
            fetchPayments () {
                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/payment/methods',
                        { params: this.$route.query }).then(response => {

                        this.pagination = response.body.result.pagination;
                        this.payments =  Object.values(response.body.result.reports);
                        this.status = response.status;

                        this.isLoading = false;
	                }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
                }
            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/payment/list.vue